export const COLOR_BY_NUMBER = {
  0: {
    color: 'green',
    type: 2,
  },
  1: {
    color: 'red',
    type: 1,
  },
  2: {
    color: 'black',
    type: 3,
  },
  3: {
    color: 'red',
    type: 1,
  },
  4: {
    color: 'black',
    type: 3,
  },
  5: {
    color: 'red',
    type: 1,
  },
  6: {
    color: 'black',
    type: 3,
  },
  7: {
    color: 'red',
    type: 1,
  },
  8: {
    color: 'black',
    type: 3,
  },
  9: {
    color: 'red',
    type: 1,
  },
  10: {
    color: 'black',
    type: 3,
  },
  11: {
    color: 'black',
    type: 3,
  },
  12: {
    color: 'red',
    type: 1,
  },
  13: {
    color: 'black',
    type: 3,
  },
  14: {
    color: 'red',
    type: 1,
  },
  15: {
    color: 'black',
    type: 3,
  },
  16: {
    color: 'red',
    type: 1,
  },
  17: {
    color: 'black',
    type: 3,
  },
  18: {
    color: 'red',
    type: 1,
  },
  19: {
    color: 'red',
    type: 1,
  },
  20: {
    color: 'black',
    type: 3,
  },
  21: {
    color: 'red',
    type: 1,
  },
  22: {
    color: 'black',
    type: 3,
  },
  23: {
    color: 'red',
    type: 1,
  },
  24: {
    color: 'black',
    type: 3,
  },
  25: {
    color: 'red',
    type: 1,
  },
  26: {
    color: 'black',
    type: 3,
  },
  27: {
    color: 'red',
    type: 1,
  },
  28: {
    color: 'black',
    type: 3,
  },
  29: {
    color: 'black',
    type: 3,
  },
  30: {
    color: 'red',
    type: 1,
  },
  31: {
    color: 'black',
    type: 3,
  },
  32: {
    color: 'red',
    type: 1,
  },
  33: {
    color: 'black',
    type: 3,
  },
  34: {
    color: 'red',
    type: 1,
  },
  35: {
    color: 'black',
    type: 3,
  },
  36: {
    color: 'red',
    type: 1,
  },
};
